module.exports = __webpack_public_path__ + "static/img/application.5dff43a9.jpg";